import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import ZoneModel from "../../models/masters/zone-model";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Zone/GetAllZone";// //{/api/Category/GetAllCategory}`)  //// "https://localhost:7054/api/Category/GetAllCategory";
export const useGetZones = createQuery<
  ZoneModel[],
  null,
  AxiosError
>({
  queryKey: ["keyZonelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});